import loadable from "@loadable/component";

export const ContactUsForm = loadable(() => import("./ContactUs/index.form"));
export const AddEditFaqForm = loadable(() =>
  import("./EditFAQSForm/index.form"),
);
export const CmsForms = loadable(() =>
  import("./CmsForm/index.form"),
);
